module.exports = __webpack_public_path__ + "img/grey_023.9c81ebde.png";